import Login from 'pages/Login';
import ForgottenPassword from 'pages/Login/ForgottenPassword';
import RegisterPassword from 'pages/Login/RegisterPassword';
import ResetPassword from 'pages/Login/ResetPassword';
import Dashboard from 'pages/Dashboard';
import DashboardMasterAgent from 'pages/Dashboard/MasterAgentView'
// import DashboardElite from 'pages/Dashboard/EliteView';
import Programs from 'pages/Programs';
import Events from 'pages/Events';
import Education from 'pages/Education';

import Document from 'pages/Document';

import Users from 'pages/Users';
import ShowUser from 'pages/Users/Show';
import Profiles from 'pages/Profiles';
import ShowProfiles from 'pages/Profiles/Show';

import Actions from 'pages/Actions';
import ShowAction from 'pages/Actions/Show/index';
import ActionStatement from 'pages/Actions/Statement';
import InnovationStatement from 'pages/Innovation/Statement';
import ScancashStatement from 'pages/Scancash/Statement';

import Innovation from 'pages/Innovation';
import ShowInnovation from 'pages/Innovation/Show';

import Scancash from 'pages/Scancash';
import FundScancash from 'pages/Scancash/Fund';
import ShowScancash from 'pages/Scancash/Show';


import Rebate from 'pages/Rebate';
import ShowRebate from 'pages/Rebate/Show/index';
import RebateStatement from 'pages/Rebate/Statement';

import Statement from 'pages/Statement';

// import QuoteRequestList from '../pages/QuoteRequest/List';
// import QuoteRequestShow from '../pages/QuoteRequest/Show';

// import ResalesList from '../pages/Resales/List';

import ResalesShow from '../pages/Resales/Show';
import Companies from '../pages/Companies';
import CompanyForm from '../pages/Companies/Show';
import Attendance from '../pages/Resales/Attendance';
// import MyOrders from '../pages/AfterSales/MyOrders';
// import Scaling from '../pages/AfterSales/Scaling';
// import Contracts from '../pages/AfterSales/Contracts';
import NewOrder from '../pages/AfterSales/NewOrder';
import MyQuotes from '../pages/BeforeSales/MyQuotes';
import NewQuote from '../pages/BeforeSales/NewQuote';
import NewComission from '../pages/Comission/NewComission';
import MyComissions from '../pages/Comission/MyComissions';
import AfterSales from '../pages/AfterSales';

import Providers from '../pages/Providers';
import ProviderShow from '../pages/Providers/Show';
import ProviderEdit from '../pages/Providers/Edit';

import FaqPage from '../pages/Faq';
import Leads from '../pages/Leads';
import Account from '../pages/Account';
import TechnicalSupport from '../pages/TechnicalSupport';

import Financial from '../pages/Financial';

import Logs from '../pages/Logs'

import SendMailRevenues from '../pages/SendMailRevenues';
import TechnicalPostSales from '../pages/TechnicalPostSales';
import Opportunities from './Opportunities';
import OpportunityForm from './Opportunities/Form'
import FaqMasterAgent from '../pages/FaqMasterAgent';
import DashboardCnaes from '../pages/Dashboard/DashboardCnaes';
import Notifications from '../pages/Notifications';
import NotificationsForm from '../pages/Notifications/form';
import TesteHubspot from './TesteHubspot';

// REPORTS
import Reports from 'pages/Reports';
import DynamicReports from './Reports/DynamicReports';

import HubspotLog from 'pages/HubspotLog';
import Company from './Company';
import AccessionForm from './AccessionForm/indexbkp';

import Config from './Config'
import Deductions from './Scancash/Deductions';
import DeductionForm from './Scancash/Deductions/form';
import Tickets from './Tickets';
import TicketForm from './Tickets/Form'

import ElitePass from './ElitePass';
import ShowElitePass from './ElitePass/Show';
import FundElitePass from './ElitePass/Fund';
import ElitePassStatement from './ElitePass/Statement';

import ScanSelect from './ScansourceSelect';
import ShowScanSelect from './ScansourceSelect/Show';
import FundScanSelect from './ScansourceSelect/Fund';
import ScanSelectStatement from './ScansourceSelect/Statement';

import DeductionList from './Deductions'
import Maintenance from './Maintenance';
import Admin from './Admin';

const PublicRoutes = [
  { pathname: '/', component: Login, exact: true },
  {
    pathname: '/forgotten-password',
    component: ForgottenPassword,
    exact: true,
  },
  { pathname: '/reset-password', component: ResetPassword, exact: true },
  { pathname: '/register-password', component: RegisterPassword, exact: true },
  ,
  {
    pathname: '/maintenance',
    component: Maintenance,
    exact: true,
  }
];

const PrivateRoutes = [
  {
    pathname: '/teste-hubspot',
    component: TesteHubspot,
    exact: true,
    permission: 'dashboard.index',
    title:'teste-hubspot'
  },
  {
    pathname: '/',
    component: Dashboard,
    exact: true,
    permission: 'dashboard.index',
    title:'Dashboard'
  },
  {
    pathname: '/config',
    component: Config,
    exact: true,
    permission: 'system.config',
    title: 'Configuração'
  },
  {
    pathname: '/company',
    component: Company,
    exact: true,
    permission: 'resale.info',
    title:'Dashboard'
  },
  {
    pathname: '/elite',
    component: DashboardMasterAgent,
    exact: true,
    permission: 'dashboard.index',
  },
  {
    pathname: '/master-agent',
    component: DashboardMasterAgent,
    exact: true,
    permission: 'dashboard.index',
  },
  {
    pathname: '/account',
    component: Account,
    exact: true,
    permission: 'account.show',
  },
  {
    pathname: '/faq-elite',
    component: FaqPage,
    exact: true,
    permission: 'faq.index',
  },
  {
    pathname: '/faq-master-agent',
    component: FaqMasterAgent,
    exact: true,
    permission: 'faq-master-agent.index',
  },
  {
    pathname: '/programs',
    component: Programs,
    exact: true,
    permission: 'programs.index',
  },
  {
    pathname: '/events',
    component: Events,
    exact: true,
    permission: 'events.index',
  },
  {
    pathname: '/education',
    component: Education,
    exact: true,
    permission: 'education.index',
  },
  // {
  //   pathname: '/elite/leads',
  //   component: Leads,
  //   exact: true,
  //   permission: 'leads.index',
  // },
  //{ pathname: '/quote-request/show/:id', component: QuoteRequestShow, exact: true },

  {
    pathname: '/profiles',
    component: Profiles,
    exact: true,
    permission: 'profile.index',
  },
  {
    pathname: '/profiles/show',
    component: ShowProfiles,
    exact: true,
    permission: 'profile.show',
  },
  {
    pathname: '/profiles/show/:id',
    component: ShowProfiles,
    exact: true,
    permission: 'profile.edit',
  },

  {
    pathname: '/users',
    component: Users,
    exact: true,
    permission: 'user.index',
  },
  {
    pathname: '/users/show',
    component: ShowUser,
    exact: true,
    permission: 'user.show',
  },
  {
    pathname: '/users/show/:id',
    component: ShowUser,
    exact: true,
    permission: 'user.edit',
  },
  {
    pathname: '/documents',
    component: Document,
    exact: true,
    permission: 'document.index',
  }, 
  {
    pathname: '/notifications',
    component: Notifications,
    exact: true,
    permission: 'send-notification'
  },
  {
    pathname: '/notifications/create',
    component: NotificationsForm,
    exact: true,
    permission: 'send-notification'
  },
  {
    pathname: '/attendance',
    component: Attendance,
    exact: true,
    permission: 'resale.attendance',
  },

  {
    pathname: '/elite/actions',
    component: Actions,
    exact: true,
    permission: 'marketing.index',
  },
  {
    pathname: '/elite/actions/show',
    component: ShowAction,
    exact: true,
    permission: 'marketing.show',
  },
  {
    pathname: '/elite/actions/statement',
    component: ActionStatement,
    exact: true,
    permission: 'marketing.statement',
  },
  {
    pathname: '/elite/innovation/statement',
    component: InnovationStatement,
    exact: true,
    permission: 'innovation.statement',
  },
  {
    pathname: '/elite/innovation/old/statement/:fiscal_year',
    component: InnovationStatement,
    exact: true,
    permission: 'innovation.statement.old',
  },
  {
    pathname: '/elite/scancash/statement',
    component: ScancashStatement,
    exact: true,
    permission: 'scancash.statement',
  },
  {
    pathname: '/elite/scancash/old/statement/:fiscal_year',
    component: ScancashStatement,
    exact: true,
    permission: 'scancash.statement.old',
  },
  {
    pathname: '/elite/scancash/deductions',
    component: Deductions,
    exact: true,
    permission: 'scancash.deductions'
  },
  {
    pathname: '/elite/scancash/deductions/add',
    component: DeductionForm,
    exact: true,
    permission: 'scancash.deductions'
  },

  {
    pathname: '/elite/deductions',
    component: DeductionList,
    exact: true,
    permission: 'scancash.deductions'
  },

  {
    pathname: '/elite/innovation',
    component: Innovation,
    exact: true,
    permission: 'innovation.list',
    title:'Inovação'
  },
  {
    pathname: '/elite/innovation/old/:fiscal_year',
    component: Innovation,
    exact: true,
    permission: 'innovation.list.old',
    title:'Inovação'
  },
  {
    pathname: '/elite/innovation/show',
    component: ShowInnovation,
    exact: true,
    permission: 'innovation.create',
    title:'Inovação - criar'
  },
  {
    pathname: '/elite/innovation/show/:id',
    component: ShowInnovation,
    exact: true,
    permission: 'innovation.edit',
    title:'Inovação - editar'
  },
  {
    pathname: '/elite/scancash',
    component: Scancash,
    exact: true,
    permission: 'scancash.list',
    title:'ScanCash'
  },
  {
    pathname: '/elite/scancash/old/:fiscal_year',
    component: Scancash,
    exact: true,
    permission: 'scancash.list.old',
    title:'ScanCash'
  },
  {
    pathname: '/elite/scancash/fund',
    component: FundScancash,
    exact: true,
    permission: 'scancash.list',
    title:'ScanCash'
  },
  {
    pathname: '/elite/scancash/show',
    component: ShowScancash,
    exact: true,
    permission: 'scancash.create',
    title:'ScanCash - criar'
  },
  {
    pathname: '/elite/scancash/show/:id',
    component: ShowScancash,
    exact: true,
    permission: 'scancash.edit',
    title:'ScanCash - editar'
  },
  {
    pathname: '/elite/elite-pass',
    component: ElitePass,
    exact: true,
    permission: 'scancash.list', //criar permissao
    title:'ScanSource Select'
  },
  {
    pathname: '/elite/elite-pass/show',
    component: ShowElitePass,
    exact: true,
    permission: 'scancash.create', //criar permissao
    title:'ScanSource Select'
  },
  {
    pathname: '/elite/elite-pass/show/:id',
    component: ShowElitePass,
    exact: true,
    permission: 'scancash.edit', //criar permissao
    title:'ScanSource Select - Editar'
  },
  {
    pathname: '/elite/elite-pass/fund',
    component: FundElitePass,
    exact: true,
    permission: 'scancash.list', //criar permissao
    title:'ScanCash'
  },
  {
    pathname: '/elite/elite-pass/statement',
    component: ElitePassStatement,
    exact: true,
    permission: 'scancash.statement',
  },
  {
    pathname: '/elite/scansource-select',
    component: ScanSelect,
    exact: true,
    permission: 'scancash.list', //criar permissao
    title:'ScanSource Select'
  },
  {
    pathname: '/elite/scansource-select/show',
    component: ShowScanSelect,
    exact: true,
    permission: 'scancash.create', //criar permissao
    title:'ScanSource Select'
  },
  {
    pathname: '/elite/scansource-select/show/:id',
    component: ShowScanSelect,
    exact: true,
    permission: 'scancash.edit', //criar permissao
    title:'ScanSource Select - Editar'
  },
  {
    pathname: '/elite/scansource-select/fund',
    component: FundScanSelect,
    exact: true,
    permission: 'scancash.list', //criar permissao
    title:'ScanCash'
  },
  {
    pathname: '/elite/scansource-select/statement',
    component: ScanSelectStatement,
    exact: true,
    permission: 'scancash.statement',
  },
  {
    pathname: '/elite/rebate',
    component: Rebate,
    exact: true,
    permission: 'rebate.index',
  },
  {
    pathname: '/elite/rebate/show',
    component: ShowRebate,
    exact: true,
    permission: 'rebate.show',
  },
  {
    pathname: '/elite/rebate/statement',
    component: RebateStatement,
    exact: true,
    permission: 'rebate.statement',
  },
  {
    pathname: '/elite/statement',
    component: Statement,
    exact: true,
    permission: 'statement.index',
  },

  {
    pathname: '/resales/show',
    component: ResalesShow,
    exact: true,
    permission: 'resale.info',
  },
  {
    pathname: '/resales/attendance',
    component: Attendance,
    exact: true,
    permission: 'resale.attendance',
  },
  {
    pathname: '/companies',
    component: Companies,
    exact: true,
    permission: 'resale.index',
  },
  {
    pathname: '/company/create',
    component: CompanyForm,
    exact: true,
    permission: 'resale.create',
  },

  // master-agent
  {
    pathname: '/master-agent/new-quote',
    component: NewQuote,
    exact: true,
    permission: 'presales.new',
  },
  {
    pathname: '/master-agent/my-quotes',
    component: MyQuotes,
    exact: true,
    permission: 'presales.index',
  },  
  {
    pathname: '/master-agent/my-quotes/opportunities',
    component: Opportunities,
    exact: true,
    permission: 'master-agent.opportunities',
  },
  {
    pathname: '/master-agent/my-quotes/opportunities/add',
    component: OpportunityForm,
    exact: true,
    permission: 'master-agent.opportunities',
  },
  {
    pathname: '/master-agent/after-sales',
    component: AfterSales,
    exact: true,
    permission: 'postsales.index',
  },
  {
    pathname: '/master-agent/new-order',
    component: NewOrder,
    exact: true,
    permission: 'postsales.new',
  },
  {
    pathname: '/master-agent/my-comissions',
    component: MyComissions,
    exact: true,
    permission: 'comissions.index',
  },
  {
    pathname: '/master-agent/new-comission',
    component: NewComission,
    exact: true,
    permission: 'comissions.new',
  },
  {
    pathname: '/master-agent/providers',
    component: Providers,
    exact: true,
    permission: 'providers.index',
  },
  {
    pathname: '/master-agent/technical-postsales',
    component: TechnicalPostSales,
    exact: true,
  },
  {
    pathname: '/resale/revenue',
    component: SendMailRevenues,
    exact: true,
    permission: 'billing.resellers'
  },
  {
    pathname: '/master-agent/provider/show/:id',
    component: ProviderShow,
    exact: true,
    permission: 'providers.show',
  },
  {
    pathname: '/master-agent/provider/edit/:id',
    component: ProviderEdit,
    exact: true,
    permission: 'providers.edit',
  },
  {
    pathname: '/master-agent/provider/edit',
    component: ProviderEdit,
    exact: true,
    permission: 'providers.edit',
  },
  {
    pathname: '/dashboard-cnaes',
    component: DashboardCnaes,
    exact: true,
    permission: 'dashboard.cnaes',
  },
  {
    pathname: '/master-agent/technical-support',
    component: TechnicalSupport,
    exact: true,
    permission: 'technical_support.index',
  },
  {
    pathname: '/financial',
    component: Financial,
    exact: true
  }, 
  {
    pathname: '/logs',
    component: Logs,
    exact: true,
    permission: 'logs.index'
  },
  //{ pathname: '/master-agent/my-orders', component: MyOrders, exact: true },
  //{ pathname: '/master-agent/scaling', component: Scaling, exact: true },
  //{ pathname: '/master-agent/contracts', component: Contracts, exact: true },

  // REPORTS
  {
    pathname: '/elite/reports',
    component: Reports,
    exact: true,
    permission: 'report.index',
  },
  {
    pathname: '/elite/reports/:report',
    component: DynamicReports,
    exact: true,
    permission: 'report.index',
  }, 
  {
    pathname: '/tickets',
    component: Tickets,
    exact: true,
    permission: 'dashboard.index' // TEMP
  },
  {
    pathname: '/tickets/add',
    component: TicketForm,
    exact: true,
    permission: 'dashboard.index' // TEMP
  },
  {
    pathname: '/tickets/:id/edit',
    component: TicketForm,
    exact: true,
    permission: 'dashboard.index' // TEMP
  },

  {
    pathname: '/hubspot-errors-log',
    component: HubspotLog,
    exact: true,
    permission: 'dashboard.log-hubspot' 
  },
  {
    pathname: '/formulario-adesao',
    component: AccessionForm,
    exact: true,
    permission: 'report.index'
  },
  {
    pathname: '/admin',
    component: Admin,
    exact: true,
    permission: 'adm-page'
  }
];

export { PublicRoutes, PrivateRoutes };
